import axios from "axios"

const setOrganisationId = (context, data) => {
  context.commit("ORGANISATION_ID", data)
}

const setOrganisation = (context, data) => {
  context.commit("ORGANISATION", data)
}

export default {
  setOrganisationId,
  setOrganisation
}
